import Controller from 'controllers/controller';
import AudioPlayerController from 'controllers/audio-player';
import Elements from 'tools/elements';
import Bus from 'tools/bus';

class AudioPlayersController extends Controller {
    ready() {
        this.bus = new Bus;
        this.elements = new Elements;
        this.controllers = [ ];
        this.controllerElements = [ ];

        this.app.loaderController.on('page-loaded', () => {
            this.findNewAudioPlayers();
        });
    }
    
    findNewAudioPlayers() {
        this.cacheElements();
        this.initControllers();
    }
    
    cacheElements() {
        this.elements.queryAll('audio-players', '.audio-player');
    }
    
    initControllers() {
        this.elements.each('audio-players', element => {
            // Don't double instantiate
            if (this.controllerElements.indexOf(element) !== -1) {
                return;
            }
            
            this.controllerElements.push(element);
            this.controllers.push(
                this.app.make(AudioPlayerController, element)
            );
        })
    }
}

export default AudioPlayersController;